import { cssColorToRgb } from "client/Misc/colorFunctions";
import { isNotNil } from "client/Misc/utils";
import {
	DOMOutputSpec,
	Mark,
	MarkSpec
} from "prosemirror-model";

export type ColorMarkAttributes = {
	color: string;
};

export const color: MarkSpec = {
	attrs: {
		color: {}
	},
	parseDOM: [
		{
			style: "color",
			getAttrs: (styleValue): ColorMarkAttributes | false => {
				if (typeof styleValue !== "string") {
					throw new Error("Expected style value at this point");
				}

				const isValidColor: boolean = isNotNil(cssColorToRgb(styleValue));
				if (!isValidColor) {
					return false;
				}

				return {
					color: styleValue
				};
			}
		}
	],
	toDOM: (node: Mark): DOMOutputSpec => {
		const {
			color
		} = (node.attrs as ColorMarkAttributes);

		return [
			"span",
			{
				style: `color: ${color};`
			},
			0
		];
	}
};